import { render, staticRenderFns } from "./VHeaderProfile.vue?vue&type=template&id=2c746b08&"
import script from "./VHeaderProfile.vue?vue&type=script&lang=ts&"
export * from "./VHeaderProfile.vue?vue&type=script&lang=ts&"
import style0 from "./VHeaderProfile.vue?vue&type=style&index=0&id=2c746b08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports